import { Spinner } from '@ntconsult/aluma-react';
import { useTranslation } from 'react-i18next';
import type { useConsultaCep } from '../hooks';

/** Aviso inline da busca de CEP, na região `aria-live` (R17, R18). Nunca bloqueia o envio. */
export function AvisoCep({
  consulta,
  cidadeNaoCasou = false,
}: {
  consulta: ReturnType<typeof useConsultaCep>;
  cidadeNaoCasou?: boolean;
}) {
  const { t } = useTranslation('formulario');
  const { endereco, buscando, falha } = consulta;
  const msgs: string[] = [];
  if (buscando) msgs.push(t('cep.buscando'));
  else if (falha)
    msgs.push(t(falha === 'nao_encontrado' ? 'cep.naoEncontrado' : 'cep.indisponivel'));
  else if (endereco) {
    msgs.push(t(endereco.parcial ? 'cep.parcial' : 'cep.preenchido'));
    if (cidadeNaoCasou && !endereco.cidadeId) msgs.push(t('cep.cidadeNaoCasou'));
  }
  return (
    <div
      aria-live="polite"
      className="flex flex-col gap-1 text-sm text-foreground-muted empty:sr-only"
    >
      {msgs.map((m, i) => (
        <p key={m} className="flex items-center gap-2">
          {buscando && i === 0 && <Spinner size="sm" aria-hidden />}
          {m}
        </p>
      ))}
    </div>
  );
}
